import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M12 3a11 11 0 0110.82 9 11 11 0 01-21.64 0A11 11 0 0112 3zm0 16a9 9 0 008.78-7 9 9 0 00-17.56 0A9 9 0 0012 19z"/>
    <path fill="#34CEFF" fillRule="evenodd" d="M12 16.5a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm1.77-2.73a2.5 2.5 0 11-3.54-3.54 2.5 2.5 0 013.54 3.54z" clipRule="evenodd"/>
  </SvgIcon>
);